import React from 'react';
import Slick from 'react-slick';
import Card from 'components_v2/common/CardV2';
import s from './SingleCardSlider.scss';

const NextArrow = props => (
  <span {...props} className={`btn next ${props.className}`}>
    <i />
  </span>
);

const PrevArrow = props => (
  <span {...props} className={`btn prev ${props.className}`}>
    <i />
  </span>
);

const settings = {
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  infinite: false,
};

const SingleCardSlider = props => (
  <>
    <div className={`${s.singleSlider} ${props.wrapperClass}`}>
      <Slick {...settings}>
        {props.data instanceof Array
          ? props.data.map((item, index) => {
              item.cs = item.primeid === '100' ? 'prime' : item.cs;
              return (
                <Card
                  data={item}
                  isVerticalTile
                  key={item.id || `${item.tn}_${index}`}
                  showDescription={props.showDescription}
                  cssObj={{
                    titleCont: s.textsize,
                    desc: s.description,
                  }}
                />
              );
            })
          : null}
      </Slick>
    </div>
  </>
);
export default React.memo(SingleCardSlider);
